module.exports = __webpack_public_path__ + "static/media/gallery_05.88eb7c4c.png";